import { AnimatedSection } from "@/hooks/useScrollAnimation";

interface PageHeroProps {
  title: string;
  subtitle?: string;
  backgroundImage: string;
  children?: React.ReactNode;
  minHeight?: string;
  objectPosition?: string;
}

const PageHero = ({ title, subtitle, backgroundImage, children, minHeight = "420px", objectPosition = "top" }: PageHeroProps) => {
  return (
    <section className="relative flex items-center justify-center px-6 lg:px-12 pt-20 pb-16 text-white overflow-hidden" style={{ minHeight }}>
      {/* Background image */}
      <div className="absolute inset-0 z-0">
        <img
          src={backgroundImage}
          alt=""
          className="w-full h-full object-cover"
          style={{ objectPosition }}
          loading="eager"
        />
        <div className="absolute inset-0 bg-deep-blue/80" />
      </div>

      {/* Content */}
      <AnimatedSection className="relative z-10 w-full max-w-[1100px] mx-auto text-center">
        <h1 className="font-heading font-bold text-2xl lg:text-4xl mb-4">{title}</h1>
        {subtitle && (
          <p className="font-body text-base text-white/80 max-w-3xl mx-auto">{subtitle}</p>
        )}
        {children}
      </AnimatedSection>
    </section>
  );
};

export default PageHero;
